// src/app/redux/actions/sectionActions.js

export const FETCH_SECTIONS_REQUEST = 'FETCH_SECTIONS_REQUEST';
export const FETCH_SECTIONS_SUCCESS = 'FETCH_SECTIONS_SUCCESS';
export const FETCH_SECTIONS_FAIL = 'FETCH_SECTIONS_FAIL';

export const SAVE_SECTION_REQUEST = 'SAVE_SECTION_REQUEST';
export const SAVE_SECTION_SUCCESS = 'SAVE_SECTION_SUCCESS';
export const SAVE_SECTION_FAIL = 'SAVE_SECTION_FAIL';

export const DELETE_SECTION_REQUEST = 'DELETE_SECTION_REQUEST';
export const DELETE_SECTION_SUCCESS = 'DELETE_SECTION_SUCCESS';
export const DELETE_SECTION_FAIL = 'DELETE_SECTION_FAIL';

export const FETCH_AVAILABLE_FIELDS_REQUEST = 'FETCH_AVAILABLE_FIELDS_REQUEST';
export const FETCH_AVAILABLE_FIELDS_SUCCESS = 'FETCH_AVAILABLE_FIELDS_SUCCESS';
export const FETCH_AVAILABLE_FIELDS_FAIL = 'FETCH_AVAILABLE_FIELDS_FAIL';

export const fetchSections = (companyId) => ({
    type: FETCH_SECTIONS_REQUEST,
    payload: companyId,
});

export const saveSection = (section) => ({
    type: SAVE_SECTION_REQUEST,
    payload: section,
});

export const deleteSection = (id) => ({
    type: DELETE_SECTION_REQUEST,
    payload: id,
});

export const fetchAvailableFields = () => ({
    type: FETCH_AVAILABLE_FIELDS_REQUEST,
});
